import { Route, Routes } from 'react-router-dom';
import HomeScreen from './pages/HomeScreen';
import GuestDetails from './pages/GuestDetails';
import SplashScreen from './pages/SplashScreen';
import OuteletList from './pages/OuteletList';
import ContactBook from './pages/ContactBook';
import History from './pages/History';
import { Empty } from 'antd';
import Thankyou from './pages/Thankyou';

function App() {

    return (
        <Routes>
            <Route path='' element={<OuteletList />}></Route>
            <Route path='home' element={<HomeScreen />}></Route>
            <Route path='splash-screen' element={<SplashScreen />}></Route>
            <Route path='guest-details' element={<GuestDetails />}></Route>
            <Route path='contact-list' element={<ContactBook />}></Route>
            <Route path='visitor-history' element={<History />}></Route>
            <Route path='page-not-found' element={<Empty />} />
            <Route path='thank-you' element={<Thankyou />} />
            <Route path='*' element={<HomeScreen />} />
        </Routes>
    );
}

export default App;
